import { FETCH_SEARCHFIELDMAPPINGS, FetchSearchFieldMappings } from './types';

// eslint-disable-next-line import/prefer-default-export
export const fetchSearchFieldMappings = (next?: string): FetchSearchFieldMappings => ({
  type: FETCH_SEARCHFIELDMAPPINGS,
  payload: {
    next,
  },
});
